/* KLIPSE — interacciones de la web nueva */
(function () {
  var fmt = function (cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); };
  var cm = function (v) { return (Math.round(v * 10) / 10).toString().replace('.', ',') + ' cm'; };
  var CHECKOUT = '/checkout';

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-kl-count]').forEach(function (el) { el.textContent = c.item_count; });
        return c;
      })
      .catch(function () { return null; });
  }

  /* Agrega y devuelve la bolsa actualizada (o null si no se pudo leer) */
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
        return refreshCount();
      });
    });
  }

  function initRail(root) {
    if (root.dataset.klInit) return; root.dataset.klInit = '1';
    var rail = root.querySelector('.kl-calle__rail');
    if (!rail) return;
    var prev = root.querySelector('.kl-round--prev');
    var next = root.querySelector('.kl-round--next');
    var dots = root.querySelector('.kl-dots');
    function step() {
      var t = rail.children[0]; if (!t) return 300;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
      return t.getBoundingClientRect().width + gap;
    }
    function pages() { return Math.max(1, Math.ceil((rail.scrollWidth - rail.clientWidth - 2) / step()) + 1); }
    function current() { return Math.min(pages() - 1, Math.round(rail.scrollLeft / step())); }
    function draw() {
      var n = pages(), c = current();
      if (dots && dots.children.length !== n) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          (function (i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Ir a la posición ' + (i + 1) + ' de ' + n);
            b.appendChild(document.createElement('span'));
            b.addEventListener('click', function () { rail.scrollTo({ left: i * step() }); });
            dots.appendChild(b);
          })(i);
        }
        dots.hidden = n < 2;
      }
      if (dots) Array.prototype.forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === c ? 'true' : 'false'); });
      if (prev) prev.hidden = c <= 0;
      if (next) next.hidden = c >= n - 1;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });
    var raf;
    rail.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(draw); }, { passive: true });
    window.addEventListener('resize', draw);
    draw();
    var vids = rail.querySelectorAll('video');
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls'); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }

  function initLook(root) {
    if (root.dataset.klInit) return; root.dataset.klInit = '1';
    var free = parseInt(root.dataset.free || '0', 10);
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-kl-item]'));
    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-kl-spot]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kl-spotcard]'));
    var total = root.querySelector('[data-kl-total]');
    var bar = root.querySelector('[data-kl-bar]');
    var ship = root.querySelector('[data-kl-ship]');
    var cta = root.querySelector('[data-kl-cta]');
    var added = false, cartTotal = null;
    function setActive(i) {
      spots.forEach(function (s, j) { s.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      cards.forEach(function (c, j) { c.classList.toggle('is-open', j === i); });
      items.forEach(function (it, j) { it.classList.toggle('is-active', j === i); });
    }
    spots.forEach(function (s, i) {
      s.addEventListener('click', function () { setActive(s.getAttribute('aria-pressed') === 'true' ? -1 : i); });
    });
    function update() {
      var sum = 0, count = 0, names = [];
      items.forEach(function (it) {
        var inc = it.querySelector('[data-kl-inc]');
        var r = it.querySelector('input[type=radio]:checked');
        var note = it.querySelector('[data-kl-note]');
        if (r && note) { var q = parseInt(r.dataset.qty, 10); note.textContent = !isNaN(q) && q > 0 ? 'Quedan ' + q + ' en talla ' + r.dataset.size : ''; }
        if (inc && inc.checked && r) { sum += parseInt(it.dataset.price, 10); count++; names.push(it.dataset.short); }
      });
      if (total) total.textContent = fmt(sum);
      if (bar) bar.style.width = free ? Math.min(100, Math.round(sum / free * 100)) + '%' : '100%';
      if (ship) ship.textContent = count === 0 ? 'Elegí al menos una prenda.' : (free && sum < free ? 'Te faltan ' + fmt(free - sum) + ' para el envío gratis.' : 'Tenés envío gratis.');
      if (cta) {
        cta.disabled = count === 0;
        cta.classList.toggle('is-go', added);
        cta.textContent = added
          ? 'Listo · Ir a pagar' + (cartTotal != null ? ' — ' + fmt(cartTotal) : '')
          : count === 0 ? 'Elegí una prenda'
          : count === items.length ? 'Agregar la pinta — ' + fmt(sum)
          : 'Agregar ' + names.join(' y ') + ' — ' + fmt(sum);
      }
    }
    items.forEach(function (it, i) { it.addEventListener('change', function () { added = false; setActive(i); update(); }); });
    if (cta) cta.addEventListener('click', function () {
      if (added) { window.location.href = CHECKOUT; return; }
      var list = [];
      items.forEach(function (it) {
        var inc = it.querySelector('[data-kl-inc]');
        var r = it.querySelector('input[type=radio]:checked');
        if (inc && inc.checked && r) list.push({ id: parseInt(r.value, 10), quantity: 1 });
      });
      if (!list.length) return;
      cta.disabled = true; cta.textContent = 'Agregando…';
      addItems(list).then(function (cart) {
        added = true; cartTotal = cart ? cart.total_price : null; update();
      }).catch(function (e) { update(); if (ship) ship.textContent = e.message; });
    });
    setActive(items.length ? 0 : -1);
    update();
  }

  function initProduct(root) {
    if (root.dataset.klInit) return; root.dataset.klInit = '1';
    var rail = root.querySelector('.kl-gal__rail');
    var count = root.querySelector('[data-kl-gcount]');
    var n = rail ? rail.children.length : 0;
    function idx() { return rail && rail.clientWidth ? Math.round(rail.scrollLeft / rail.clientWidth) : 0; }
    function gset() { if (count && n) count.textContent = (idx() + 1) + ' / ' + n; }
    root.querySelectorAll('[data-kl-gnav]').forEach(function (b) {
      b.addEventListener('click', function () { if (!n) return; var t = (idx() + parseInt(b.dataset.klGnav, 10) + n) % n; rail.scrollTo({ left: t * rail.clientWidth }); });
    });
    if (rail) rail.addEventListener('scroll', function () { requestAnimationFrame(gset); }, { passive: true });
    gset();

    var form = root.querySelector('[data-kl-form]');
    if (!form) return;
    var stock = root.querySelector('[data-kl-stock]');
    var btn = root.querySelector('[data-kl-add]');
    var msg = root.querySelector('[data-kl-msg]');
    var variants = Array.prototype.slice.call(form.querySelectorAll('input[name=id]'));
    function sync() {
      var r = form.querySelector('input[name=id]:checked');
      if (!r) return;
      var q = parseInt(r.dataset.qty, 10);
      if (stock) stock.textContent = !isNaN(q) && q > 0 ? 'Quedan ' + q + ' en talla ' + r.dataset.size : '';
      if (btn) { btn.disabled = false; btn.classList.remove('is-done'); btn.textContent = btn.dataset.label + ' — ' + btn.dataset.price; }
      if (msg) msg.hidden = true;
    }
    /* Confirmación: qué se agregó, cuánto falta para el envío gratis y el paso siguiente */
    function showAdded(cart, size) {
      if (!msg) return;
      var okt = msg.querySelector('[data-kl-okt]');
      var go = msg.querySelector('[data-kl-go]');
      var nudge = msg.querySelector('[data-kl-nudge]');
      var nt = msg.querySelector('[data-kl-nudget]');
      var comp = msg.querySelector('[data-kl-comp]');
      var free = parseInt(msg.dataset.free || '0', 10) * 100;
      if (okt) okt.textContent = 'Listo. Talla ' + size + ' en tu bolsa';
      if (go) go.textContent = 'Ir a pagar' + (cart ? ' — ' + fmt(cart.total_price) : '');
      if (nudge) {
        if (!cart || !free) {
          nudge.hidden = true;
        } else {
          var falta = free - cart.total_price;
          var compIn = cart.items.some(function (it) { return String(it.product_id) === msg.dataset.comp; });
          if (nt) nt.textContent = falta > 0 ? 'Te faltan ' + fmt(falta) + ' para el envío gratis.' : 'Tenés envío gratis.';
          if (comp) comp.hidden = falta <= 0 || compIn;
          nudge.hidden = false;
        }
      }
      msg.hidden = false;
    }
    form.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') sync(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = form.querySelector('input[name=id]:checked');
      if (!r || !btn) return;
      btn.disabled = true; btn.textContent = 'Agregando…';
      addItems([{ id: parseInt(r.value, 10), quantity: 1 }])
        .then(function (cart) {
          btn.textContent = 'Agregado a la bolsa';
          btn.classList.add('is-done');
          showAdded(cart, r.dataset.size);
        })
        .catch(function (err) { btn.textContent = err.message; btn.disabled = false; });
    });
    sync();

    var g = root.querySelector('[data-kl-guia]');
    if (!g) return;
    var data;
    try { data = JSON.parse(g.querySelector('[data-kl-guia-json]').textContent); } catch (e) { return; }
    if (!data || !data.medidas || !data.medidas.length) return;
    var ranges = Array.prototype.slice.call(g.querySelectorAll('input[type=range]'));
    var out = {
      size: g.querySelector('[data-kl-rsize]'), why: g.querySelector('[data-kl-rwhy]'), stock: g.querySelector('[data-kl-rstock]'),
      pick: g.querySelector('[data-kl-pick]'), notify: g.querySelector('[data-kl-notify]')
    };
    var cells = Array.prototype.slice.call(g.querySelectorAll('[data-col]'));
    var rec = 0, picked = false;
    function calc() {
      var vals = ranges.map(function (r) { return parseFloat(r.value); });
      ranges.forEach(function (r, i) { var o = g.querySelector('[data-kl-rval="' + i + '"]'); if (o) o.textContent = cm(vals[i]); });
      var best = 0, bd = Infinity;
      data.medidas[0].valores.forEach(function (v, i) { var d = Math.abs(v - vals[0]); if (d <= bd) { best = i; bd = d; } });
      rec = best;
      var size = data.tallas[best];
      var parts = data.medidas.map(function (m, i) {
        var diff = Math.round((m.valores[best] - vals[i]) * 10) / 10;
        var name = String(m.nombre).toLowerCase();
        return diff === 0 ? 'lo mismo de ' + name : (diff > 0 ? cm(diff) + ' más de ' + name : cm(-diff) + ' menos de ' + name);
      });
      out.size.textContent = size;
      out.why.textContent = 'Comparada con tu prenda, la ' + size + ' tiene ' + parts.join(' y ') + '.';
      var v = variants.filter(function (x) { return x.dataset.size === size; })[0];
      var q = v ? parseInt(v.dataset.qty, 10) : NaN;
      var avail = v && !v.disabled;
      out.stock.textContent = !v ? '' : (avail ? (!isNaN(q) && q > 0 ? 'Quedan ' + q + ' en talla ' + size + '.' : 'Disponible.') : 'La ' + size + ' está agotada por ahora.');
      out.pick.hidden = !avail;
      if (out.notify) { out.notify.hidden = !!avail; out.notify.textContent = 'Avisame cuando vuelva la ' + size; }
      out.pick.textContent = picked && v && v.checked ? 'Talla ' + size + ' elegida' : 'Elegir talla ' + size;
      cells.forEach(function (c) { c.classList.toggle('is-rec', parseInt(c.dataset.col, 10) === best); });
    }
    ranges.forEach(function (r) { r.addEventListener('input', function () { picked = false; calc(); }); });
    out.pick.addEventListener('click', function () {
      var size = data.tallas[rec];
      var v = variants.filter(function (x) { return x.dataset.size === size; })[0];
      if (v && !v.disabled) { v.checked = true; picked = true; sync(); calc(); }
    });
    calc();
  }

  function initLista(form) {
    if (form.dataset.klInit) return; form.dataset.klInit = '1';
    form.addEventListener('submit', function () {
      var wa = form.querySelector('[data-kl-wa]');
      var tags = form.querySelector('input[name="contact[tags]"]');
      if (!wa || !tags) return;
      var d = wa.value.replace(/\D/g, '');
      tags.value = tags.dataset.base + (d.length >= 7 ? ',whatsapp-57' + d : '');
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-kl-rail]').forEach(initRail);
    scope.querySelectorAll('[data-kl-look]').forEach(initLook);
    scope.querySelectorAll('[data-kl-product]').forEach(initProduct);
    scope.querySelectorAll('[data-kl-lista]').forEach(initLista);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();